'use strict';

$(document).ready(function () {
    require('./thirdParty/duets_fr').init();
});
